//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'

import { confirmWithPromise } from '@utils/helpers'

import { CheckAvailableChats } from '@api/chat.service'

// const SINGLE_CART = 1

export default {
  name: 'CartView',
  props: {
    info: {
      default: () => {},
    },
    showShopInfo: {
      default: false,
    },
    isModal: {
      default: true,
    },
  },
  data() {
    return {
      order_page: window.order_page,
      index_page: window.baseUrl,
      currency: window.currency,
      oneClickOrderEnabled: window.is_one_click_order_enabled,
      chats: {},
    }
  },
  async mounted() {
    await this.getCart()
    setTimeout(async () => {
      await this.checkChats()
    }, 0);
  },
  computed: {
    ...mapState('cart', [
      'cart', 'isCartLoading', 'isEmpty',
    ]),
    langPrefix() {
      const match = window.location.pathname.match(/^\/(ru|uk)/)
      return match ? `/${match[1]}` : ''
    },
  },
  methods: {
    ...mapActions('cart', [
      'getCart',
      'clearCart',
    ]),
    getChat(id) {
      return this.chats[id] || 'None'
    },
    async checkChats() {
      if (!window.authent) return
      this.cart.forEach(async element => {
        const { id } = (await CheckAvailableChats.execute({ shop: element.shop.id }))
        this.$set(this.chats, element.shop.id, id)
        this.chats[element.shop.id] = id
      })
    },
    initCheckout(shop) {
      console.log(`${this.order_page}${shop}/`);
      window.location.href = `${this.order_page}${shop}/`
      // console.log(this.cart.length > SINGLE_CART, `${this.order_page}${shop}/`)
      // if (this.cart.length > SINGLE_CART) {
      //   return
      // }
      // window.location.href = this.order_page
    },
    async clearAllCart() {
      const question = this._('Вы действительно хотите очистить корзину?')
      try {
        await confirmWithPromise(question, this)
        this.clearCart()
      } catch (e) {
        console.log(e)
      }
    },
  },
}
